import React from 'react'
import { Link } from 'react-router-dom'

export const MedicalTourismInner = () => {
  return (
    <>
        <>
        <section class="service-details section-space">
            <div class="container">
                <div class="row flex-xl-row flex-column-reverse">
                  <h3 className="section__title mb-0 text-capitalize title-animation py-5">
                We are a team of multidisciplinary professionals with extensive industry experience, ready to deliver top-tier regulatory and quality services with speed and efficiency. Our adaptable resources are designed to meet your unique needs, ensuring that your perspective is at the forefront of our work. Whether it's a one-time project or a long-term collaboration, we are committed to supporting you at every stage of your journey, helping you achieve your business goals.
                </h3>
                    <div class="col-xl-4">
                        <div class="sidebar sidebar-rr-sticky">
                            <div class="sidebar__widget-service mb-30">
                            <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i> </Link>
                            <Link to="/pharmaceutical-details">Pharmaceutical & Biotech industry<i class="fa-solid fa-plus"></i> </Link>
                            <Link to="/service">Healthcare Providers <i class="fa-solid fa-plus"></i> </Link>

                            </div>

                            <div class="sidebar__widget-contact__service text-center">
                                <h4 class="mb-25 title-animation text-capitalize">Are You ready to contact with us</h4>
                                <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i>(+86) 19811976744</a></p>

                                <Link to="/contact-us#" class="rr-btn">
                                    <span class="btn-wrap">
                                        <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                                        <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
                                    </span>
                                </Link>
                </div>
                        </div>
                    </div>
                    <div class="col-xl-8">
                        <div class="service-details__content">
                            <div class="service-details__content-media mb-20">
                                <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="img not found"/>
                            </div>

                            <h2 class="title-animation mb-20">	Medical Tourism  </h2>

                            <p class="mb-20">SQUARE MEDTECH team is a mixture of trained healthcare professionals with Cardiovascular Medicine (Cath-Lab specialty), Ultra-sonography, Dentistry, Orthopedic Surgery, General Practitioners, Nurse, multidisciplinary clinical specialists and with Engineering professional backgrounds for MedTech development. Our team of experienced professionals brings together a wealth of knowledge and expertise in clinical research, regulatory affairs, data management, and patient care. We are partnered with multiple hospitals for MedTech development. So, we have full efficiency to handle professionally international patients who want to receive medical care service under our Medical Tourism facilities with our affiliated hospitals.    </p>

                            <p class="mb-20">SQUARE MEDTECH is Your Trusted Gateway to World-Class Healthcare. We specialize in orchestrating seamless medical journeys for international patients, connecting you with leading specialists and advanced treatments across our global network. Our dedicated concierge team manages every detail—from personalized treatment planning and transparent cost estimates to visa coordination, travel logistics, and culturally attuned in-country support. Experience stress-free care with seamless hospital integration, language interpretation, and continuous coordination. Trust SQUARE MEDTECH to transform complex medical travel into a focused healing journey, prioritizing your recovery while delivering exceptional, value-driven care. </p>


                            <h3 class="title-animation mb-10">Our Expertise in Medical Tourism</h3>

                            <p class="mb-30">At SQUARE MEDTECH, we specialize in assisting complicated cases patients to navigate the complexities during the treatment at our affiliated hospitals. Since we are a company with multidisciplinary specialists, for each patients our dedicated team which contains at least one medical professional support both of the patients & our affiliated hospitals seamlessly.  </p>
                            
                        <h3>How SQUARE MEDTECH Can Support in Medical Tourism:</h3>

                        <ul class="mb-40 py-3">
                           <li>
                                <span><i className="fa-solid fa-check"></i></span>
                                Multilingual patient advocacy
                            </li>
                            <li>
                                <span><i className="fa-solid fa-check"></i></span>
                                Pre-treatment evaluations
                            </li>
                            <li>
                                <span><i className="fa-solid fa-check"></i></span>
                                Personalized treatment plans
                            </li>
                            <li>
                                <span><i className="fa-solid fa-check"></i></span>
                                Transparent Procedure Costing
                            </li>
                            <li>
                                <span><i className="fa-solid fa-check"></i></span>
                                Post-treatment follow-up
                            </li>
                            <li>
                                <span><i className="fa-solid fa-check"></i></span>
                                Diagnostic imaging & lab coordination
                            </li>
                            <li>
                                <span><i className="fa-solid fa-check"></i></span>
                                Post-operative & rehabilitation programs
                            </li>
                            <li>
                                <span><i className="fa-solid fa-check"></i></span>
                                Multi-disciplinary care coordination
                            </li>
                            <li>
                                <span><i className="fa-solid fa-check"></i></span>
                                Surgery & Medication management
                            </li>
                            <li>
    <span><i className="fa-solid fa-check"></i></span>
    Recovery timeline management
  </li>
  <li>
    <span><i className="fa-solid fa-check"></i></span>
    Telemedicine follow-up & remote monitoring
  </li>
  <li>
    <span><i className="fa-solid fa-check"></i></span>
    Medical Travel Documentation
  </li>
  <li>
    <span><i className="fa-solid fa-check"></i></span>
    Visa assistance & documentation
  </li>
  <li>
    <span><i className="fa-solid fa-check"></i></span>
    Family support & accommodation assistance
  </li>
  <li>
    <span><i className="fa-solid fa-check"></i></span>
    Insurance claim assistance
  </li>
                        </ul>

                            {/* <div class="row">
                                <div class="col-lg-7">
                                    <div class="service-details__content-media-item service-details__content-media-item-1">
                                        <div class="service-details__content-media-item_img mb-10">
                                            <img src="./assets/imgs/service-details/service-details-2.jpg" class="img-fluid" alt="img not found"/>
                                        </div>
                                        <h4 class="title-animation mb-15">Wellness Unleashing Your Health Potential</h4>
                                        <p>Web designing in a powerful way of just no an only professions, however, in a passion for our Company. We have to a tendency to believe the idea that smart looking of any website on visitors.Web designing in a powerful way of just not an only profession Web </p>
                                    </div>
                                </div>
                                <div class="col-lg-5">
                                    <div class="service-details__content-media-item service-details__content-media-item-2">
                                        <div class="service-details__content-media-item_img mb-10">
                                            <img src="./assets/imgs/service-details/service-details-3.jpg" class="img-fluid" alt="img not found"/>
                                        </div>
                                        <h4 class="title-animation mb-15">Wellness Weaves Crafting </h4>
                                        <p>Web designing in a powerful way of just not an only professions, however, in a passion for our Company. </p>
                                    </div>
                                </div>
                            </div> */}

                        </div>
                    </div>
                </div>
            </div>
        </section>

</>
    </>
  )
}
